exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=date]{background-color:#f1f1f1;border-radius:5px;height:auto;padding:0}", ""]);

// exports
